(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const autocollapses = document.querySelectorAll('.collection--description.autocollapse');

  autocollapses.forEach(container => {

    const children = Array.from(container.childNodes);
    let firstParagraph = null;

    // Zoek eerste <p> in descendants
    container.querySelectorAll('p').forEach(p => {
      if(!firstParagraph) firstParagraph = p;
    });

    if(firstParagraph && container.querySelectorAll('p').length > 1) {
      // Preview div met eerste <p>
      const previewDiv = document.createElement('div');
      previewDiv.className = 'collection-description--preview';
      previewDiv.appendChild(firstParagraph.cloneNode(true));

      // Full content div met alles behalve eerste <p>
      const fullDiv = document.createElement('div');
      fullDiv.className = 'collection-description--full';
      fullDiv.style.display = 'none';

      children.forEach(node => {
        const clone = node.cloneNode(true);
        if(clone.contains(firstParagraph)) {
          const pInClone = clone.querySelector('p');
          if(pInClone) pInClone.remove();
        }
        fullDiv.appendChild(clone);
      });

      // Read more knop
      const btn = document.createElement('button');
      btn.className = 'collection-readmore-btn button-primary';
      btn.textContent = 'Read more';

      btn.addEventListener('click', () => {
        const isHidden = fullDiv.style.display === 'none';
        fullDiv.style.display = isHidden ? 'block' : 'none';
        previewDiv.style.display = isHidden ? 'none' : 'block';
        btn.textContent = isHidden ? 'Read less' : 'Read more';
      });

      // Voeg toe aan container
      container.innerHTML = '';
      container.appendChild(previewDiv);
      container.appendChild(btn);
      container.appendChild(fullDiv);

    } else {
      // Slechts 1 <p> of geen <p>, alles behouden
      container.innerHTML = '';
      children.forEach(node => container.appendChild(node.cloneNode(true)));
    }

    container.classList.add('loaded');
  });
});

  } catch(e) { console.error(e); }
})();
})();
